import { render, staticRenderFns } from "./PayableReceivableRow.vue?vue&type=template&id=b4e0e998&scoped=true&"
import script from "./PayableReceivableRow.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableRow.vue?vue&type=script&lang=js&"
import style0 from "./PayableReceivableRow.vue?vue&type=style&index=0&id=b4e0e998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e0e998",
  null
  
)

export default component.exports